var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(_vm.showAlert)?_c('div',{staticClass:"alert-container"},[_c('div',{staticClass:"alert",class:_vm.alertType},[_vm._v(" "+_vm._s(_vm.alertMessage)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }